/**
 * Utilitaire de détection de contexte d'administration (Administra Zeyilo)
 * 
 * Règles :
 * 1. En Production :
 *    Accessible UNIQUEMENT si le nom de domaine est strictement 'administra.zeyilo.com'.
 *    Toute tentative d'accès via zeyilo.com est bloquée (isolation totale).
 * 
 * 2. En Développement (dev.zeyilo.com, localhost, etc.) :
 *    Accessible via 'administra.zeyilo.com' (si configuré dans hosts ou DNS)
 *    OU via le chemin '/admin' sur dev.zeyilo.com ou localhost pour tester facilement.
 */

export function isAdminHost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  return hostname === 'administra.zeyilo.com' || hostname.startsWith('administra.');
}

export function isDevEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  return (
    Boolean((import.meta as any).env?.DEV) ||
    hostname === 'dev.zeyilo.com' ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.')
  );
}

export function isAdminContext(): boolean {
  if (typeof window === 'undefined') return false;

  // 1. Accès via le sous-domaine administra
  if (isAdminHost()) {
    return true;
  }

  // 2. En dev, accès via le chemin /admin
  if (isDevEnvironment()) {
    const pathname = window.location.pathname.toLowerCase();
    if (pathname === '/admin' || pathname.startsWith('/admin/')) {
      return true;
    }
  }

  return false;
}

/**
 * Détecte si la requête provient du domaine public des boutiques shop.zeyilo.com
 */
export function isShopHost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  return hostname === 'shop.zeyilo.com' || hostname.startsWith('shop.');
}

/**
 * URL publique complète d'une boutique :
 * - En Production sur domaine dédié aux boutiques (shop.zeyilo.com) : https://shop.zeyilo.com/ma-marque
 * - En Développement (dev.zeyilo.com, localhost) ou domaine principal : https://.../shop/ma-marque
 */
export function getBoutiqueUrl(slug: string): string {
  const cleanSlug = (slug || '').trim().toLowerCase();
  if (typeof window !== 'undefined' && (isDevEnvironment() || !isShopHost())) {
    return `${window.location.origin}/shop/${cleanSlug}`;
  }
  return `https://shop.zeyilo.com/${cleanSlug}`;
}

/**
 * URL courte affichée au commerçant pour ses bio TikTok, Instagram & Statut WhatsApp :
 * - En Production sur domaine shop.zeyilo.com : shop.zeyilo.com/ma-marque
 * - En Développement : dev.zeyilo.com/shop/ma-marque
 */
export function getBoutiqueDisplayUrl(slug: string): string {
  const cleanSlug = (slug || '').trim().toLowerCase();
  if (typeof window !== 'undefined' && (isDevEnvironment() || !isShopHost())) {
    return `${window.location.host}/shop/${cleanSlug}`;
  }
  return `shop.zeyilo.com/${cleanSlug}`;
}
